(function (factory) {
    typeof define === 'function' && define.amd ? define(factory) :
    factory();
}((function () { 'use strict';

    var Menu = function Menu() {
        this.initializeEvents();
    };

    Menu.prototype.initializeEvents = function initializeEvents () {
        var burger = document.querySelector('.burger');
        var megamenu = document.querySelector('.megamenu');
        var menu = document.querySelector('.menu');
        var logo = document.querySelector('.logo');
        var headerEl = document.querySelector('header');
        burger.addEventListener("click", function (event) {
            var classHidden = 'is-hidden';
            if (megamenu.classList.contains(classHidden)) {
                megamenu.classList.remove(classHidden);
                document.documentElement.style.overflow = 'hidden';
                headerEl.style.height = '5.6rem';
            } else {
                megamenu.classList.add(classHidden);
                document.documentElement.style.overflow = '';
                headerEl.style.height = '8.6rem';
            }
            if (menu.classList.contains(classHidden)) {
                menu.classList.remove(classHidden);
            } else {
                menu.classList.add(classHidden);
            }
            if (logo.classList.contains(classHidden)) {
                logo.classList.remove(classHidden);
            } else {
                logo.classList.add(classHidden);
            }
        });
    };

    // Assurer que le DOM est chargé avant d'exécuter le script
    document.addEventListener("DOMContentLoaded", function() {
        var burgerToggle = document.getElementById('toggle');
        setTimeout(function () {
            burgerToggle.checked = false;
        }, 100);
    });

    var Theme = function Theme() {
        this.currentFontSizePercent = 62.5;
        this.minFontSizePercent = 32.5;
        this.maxFontSizePercent = 92.5;

        this.initializeEvents();
        this.initializeTheme();
    };

    Theme.prototype.initializeEvents = function initializeEvents () {
            var this$1 = this;

        var themeButton = document.querySelector('.theme__color-btn');
        themeButton.addEventListener("click", function (event) {
            event.preventDefault();
            this$1.changeThemeColors();
        });

        var themeFontDecrease = document.querySelector('.theme__font-btn-decrease');
        themeFontDecrease.addEventListener("click", function (event) {
            event.preventDefault();
            this$1.decreaseFontSize();
        });

        var themeFontIncrease = document.querySelector('.theme__font-btn-increase');
        themeFontIncrease.addEventListener("click", function (event) {
            event.preventDefault();
            this$1.increaseFontSize();
        });
    };

    Theme.prototype.initializeTheme = function initializeTheme () {
        var savedMode = localStorage.getItem('themeMode') || 'dark';
        this.applyTheme(savedMode);
    };

    Theme.prototype.applyTheme = function applyTheme (mode) {
        var body = document.body;
        body.classList.toggle('light-mode', mode === 'light');

        // = Effects
        // -----------------------------
        document.querySelectorAll('.glitch img').forEach(function (element) {
            element.classList.toggle('img-light-mode', mode === 'light');
        });
    };

    Theme.prototype.changeThemeColors = function changeThemeColors () {
        var currentMode = localStorage.getItem('themeMode') || 'dark';
        var newMode = currentMode === 'dark' ? 'light' : 'dark';
        localStorage.setItem('themeMode', newMode);
        this.applyTheme(newMode);
    };

    Theme.prototype.increaseFontSize = function increaseFontSize () {
        if (this.currentFontSizePercent + 10 <= this.maxFontSizePercent) {
            this.currentFontSizePercent += 10;
            this.applyFontSize();
        }
    };

    Theme.prototype.decreaseFontSize = function decreaseFontSize () {
        if (this.currentFontSizePercent - 10 >= this.minFontSizePercent) {
            this.currentFontSizePercent -= 10;
            this.applyFontSize();
        }
    };

    Theme.prototype.applyFontSize = function applyFontSize () {
        document.body.style.fontSize = (this.currentFontSizePercent) + "%";
        document.documentElement.style.fontSize = (this.currentFontSizePercent) + "%";
    };

    var Ecoindex = function Ecoindex() {
        this.SCROLL_THRESHOLD_START = 1000;
        this.SCROLL_THRESHOLD_END = 1200;
        this.initializeEvents();
    };

    Ecoindex.prototype.initializeEvents = function initializeEvents () {
            var this$1 = this;

        window.addEventListener('scroll', function () {
            var ecoindexBadge = document.getElementById('ecoindex-badge');
            var opacity = 1;
            var scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

            if (scrollPosition >= this$1.SCROLL_THRESHOLD_START && scrollPosition <= this$1.SCROLL_THRESHOLD_END) {
                opacity = 1 - ((scrollPosition - this$1.SCROLL_THRESHOLD_START) / (this$1.SCROLL_THRESHOLD_END - this$1.SCROLL_THRESHOLD_START));
            } else if (scrollPosition > this$1.SCROLL_THRESHOLD_END) {
                opacity = 0;
            }

            if (ecoindexBadge) {
                ecoindexBadge.style.opacity = opacity;
                ecoindexBadge.style.pointerEvents = opacity === 0 ? 'none' : 'auto';
            }
        });
    };

    var Social = function Social() {
        this.initializeEvents();
    };

    Social.prototype.initializeEvents = function initializeEvents () {
        var copyUrlButton = document.querySelector('.social-logo .link');
        var tooltip = document.querySelector(".tooltiptext");
        if(copyUrlButton) {
            copyUrlButton.addEventListener("click", function (event) {
                event.preventDefault();
                var urlStr = window.location.href.toString();
                navigator.clipboard.writeText(urlStr);
                tooltip.innerHTML = "URL copied";
            });
            copyUrlButton.addEventListener("mouseout", function (event) {
                event.preventDefault();
                tooltip.innerHTML = "Copy URL link";
            });
        }
    };

    var Formation = function Formation() {
        this.scrollY = 0;
        this.initializeEvents();
    };

    Formation.prototype.initializeEvents = function initializeEvents () {
        var self = this;
        var actionBanner = document.querySelector('.detailed-template-action');
        var footerContainer = document.querySelector('footer .container--full');
        window.onscroll = function () {
            self.scrollY = window.scrollY;
            var cssClass = 'is-displayed';
            var scrollLength = 700;
            if (self.scrollY >= scrollLength && actionBanner && !actionBanner.classList.contains(cssClass)) {
                actionBanner.classList.add(cssClass);
                footerContainer.style.marginBottom = "7rem";
            } else if (self.scrollY < scrollLength && actionBanner && actionBanner.classList.contains(cssClass)) {
                actionBanner.classList.remove(cssClass);
                footerContainer.style.marginBottom = "0";
            }
        };

        // Subscribe formation buttons
        document.querySelectorAll('button.register-formation').forEach(function (element) {
            element.addEventListener("click", function (event) {
                event.preventDefault();
                window.open("/contact?form=form4&formation=" + element.getAttribute('data-formation'), '_self');
            });
        });
    };

    var Contact = function Contact() {
        this.initializeEvents();
    };

    Contact.prototype.initializeEvents = function initializeEvents () {
        document.getElementById('file-input').addEventListener('change', this.handleFileInputChange.bind(this));
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this.handleDOMContentLoaded.bind(this));
        } else {
            this.handleDOMContentLoaded();
        }
    };

    Contact.prototype.handleFileInputChange = function handleFileInputChange (event) {
        var fileList = document.getElementById('file-list');
        fileList.innerHTML = '';

        for (var i = 0; i < event.target.files.length; i++) {
            var file = event.target.files[i];
            var li = document.createElement('li');
            li.textContent = file.name;
            fileList.appendChild(li);
        }
    };

    Contact.prototype.handleDOMContentLoaded = function handleDOMContentLoaded (event) {
        this.initializeTagClickEvents();
        this.displayActiveSelect();
        this.processURLParams();
    };

    Contact.prototype.initializeTagClickEvents = function initializeTagClickEvents () {
            var this$1 = this;

        document.querySelectorAll('.contact__page__right .tag').forEach(function (tag) {
            tag.addEventListener('click', function (event) {
                this$1.updateFormFields(event.currentTarget.getAttribute('data-form'));
                this$1.updateActiveTag(event.currentTarget);
            });
        });
    };

    Contact.prototype.displayActiveSelect = function displayActiveSelect () {
        var activeSelectValue = document.getElementById('active-form-select').getAttribute('value');
        if(activeSelectValue == 'subject') {
            this.updateFormFields('#form1');
        } else if(activeSelectValue == 'job') {
            this.updateFormFields('#form2');
        } else if(activeSelectValue == 'working') {
            this.updateFormFields('#form3');
        } else if(activeSelectValue == 'formation') {
            this.updateFormFields('#form4');
        }
    };

    Contact.prototype.updateActiveTag = function updateActiveTag (currentTag) {
        document.querySelectorAll('.tag').forEach(function (tag) {
            tag.classList.remove('tag-active');
        });
        currentTag.classList.add('tag-active');
    };

    Contact.prototype.updateFormFields = function updateFormFields (tag) {
        var jobField = document.querySelector('.job-field');
        var projectField = document.querySelector('.subject-field');
        var formationField = document.querySelector('.formation-field');
        var workingField = document.querySelector('.working-field');

        var allInputs = [document.getElementById('subject'), document.getElementById('job'), document.getElementById('formation'), document.getElementById('working')];
        allInputs.forEach(function (input) {
            if (input) { input.removeAttribute('required'); }
        });

        if (tag === '#form1') {
            jobField.style.display = 'none';
            formationField.style.display = 'none';
            projectField.style.display = 'flex';
            workingField.style.display = "none";
            document.getElementById('active-form-select').setAttribute('value', 'subject');
            document.getElementById('subject').setAttribute('required', '');
        } else if (tag === '#form2') {
            jobField.style.display = 'flex';
            projectField.style.display = 'none';
            formationField.style.display = 'none';
            workingField.style.display = "none";
            document.getElementById('active-form-select').setAttribute('value', 'job');
            document.getElementById('job').setAttribute('required', '');
        } else if (tag === '#form3') {
            jobField.style.display = 'none';
            projectField.style.display = 'none';
            formationField.style.display = 'none';
            workingField.style.display = "flex";
            document.getElementById('active-form-select').setAttribute('value', 'working');
            document.getElementById('working').setAttribute('required', '');
        } else if (tag === '#form4') {
            jobField.style.display = 'none';
            projectField.style.display = 'none';
            formationField.style.display = 'flex';
            workingField.style.display = "none";
            document.getElementById('active-form-select').setAttribute('value', 'formation');
            document.getElementById('formation').setAttribute('required', '');
        }
    };

    Contact.prototype.processURLParams = function processURLParams () {
        var urlParams = new URLSearchParams(window.location.search);

        var formToOpen = urlParams.get('form');

        if (formToOpen) {
            var tagToClick = document.querySelector((".tag[data-form=\"#" + formToOpen + "\"]"));
            if (tagToClick) {
                tagToClick.click();
            }
        }


        this.setSelectedOption('title', 'job');
        this.setSelectedOption('formation', 'formation');
        this.toggleBudgetField();
        this.listenToSubjectChange();
    };

    Contact.prototype.setSelectedOption = function setSelectedOption (urlParam, selectId) {
        var value = new URLSearchParams(window.location.search).get(urlParam);
        if (value) {
            var select = document.getElementById(selectId);
            Array.from(select.options).forEach(function (option) {
                if (option.value === decodeURIComponent(value)) {
                    option.selected = true;
                }
            });
        }
    };

    Contact.prototype.toggleBudgetField = function toggleBudgetField () {
        var subject = document.getElementById('subject').value;
        var budgetField = document.querySelector('.budgetfield');
        var projectsRequiringBudget = ["Création / refonte site internet vitrine ou e-commerce", "Assistance technique ou TMA"];
        if (budgetField) {
            budgetField.style.display = projectsRequiringBudget.includes(subject) ? 'block' : 'none';
        }
    };

    Contact.prototype.listenToSubjectChange = function listenToSubjectChange () {
            var this$1 = this;

        document.getElementById('subject').addEventListener('change', function () { return this$1.toggleBudgetField(); });
    };

    var Home = function Home() {
        this.initializeEvents();
    };

    Home.prototype.initializeEvents = function initializeEvents () {
        if (window.innerWidth > 768) {
            // If touch-screen (mobile) device, create double tap event on homepage blocs
            if ("ontouchstart" in document.documentElement) {
                var knowMoreLink = '.discover__grid a.know-more';
                var classVisible = 'is-visible';
                document.querySelectorAll('.discover__grid a.discover').forEach(function (element) {
                    element.addEventListener('click', function (event) {
                        event.preventDefault();
                        document.querySelectorAll(knowMoreLink).forEach(function (more) {
                            more.classList.remove(classVisible);
                        });
                        element.nextSibling.nextSibling.classList.add(classVisible);
                    });
                });
                document.querySelectorAll(knowMoreLink).forEach(function (more) {
                    more.addEventListener('click', function (event) {
                        more.classList.remove(classVisible);
                    });
                });

                // Ajoute un gestionnaire d'événements sur le document pour gérer les clics en dehors des éléments 'discover'
                document.addEventListener('click', function (event) {
                    var target = event.target; // L'élément qui a été cliqué
                    var isDiscoverElementClicked = target.closest('.discover__grid a.discover') || target.closest(knowMoreLink);

                    // Si l'élément cliqué n'est pas un élément 'discover' ni un lien 'en savoir plus'
                    if (!isDiscoverElementClicked) {
                        // Retire la classe 'is-visible' de tous les éléments 'en savoir plus'
                        document.querySelectorAll(knowMoreLink).forEach(function (more) {
                            more.classList.remove(classVisible);
                        });
                    }
                });
            }
        }
    };

    var Accessibility = function Accessibility() {
        this.initializeEvents();
    };

    Accessibility.prototype.initializeEvents = function initializeEvents () {

    };


    var toggleDyslexic = document.getElementById('toggleDyslexic');
    var toggleColor = document.getElementById('toggleColor');
    var bodyElement = document.body;

    // Fonction pour appliquer la police en fonction de l'état
    function applyFont(isOn) {
        if (isOn) {
            bodyElement.classList.add('dyslexic-font');
            toggleDyslexic.checked = true;  
        } else {
            bodyElement.classList.remove('dyslexic-font');  
            toggleDyslexic.checked = false; 
        }
    }

    // Vérifier si une valeur est déjà stockée dans le localStorage
    var savedFontPreference = localStorage.getItem('fontPreference');


    if (savedFontPreference) {
        applyFont(savedFontPreference === 'true');
    }

    toggleDyslexic.addEventListener('change', function () {
        var isOn = this.checked; 

        applyFont(isOn);
        localStorage.setItem('fontPreference', isOn);
    });


    // Fonction pour appliquer la couleur en fonction de l'état
    function applyColor(isOn) {
        if (isOn) {
            bodyElement.classList.add('color-contrast'); 
            toggleColor.checked = true;  
        } else {
            bodyElement.classList.remove('color-contrast'); 
            toggleColor.checked = false; 
        }
    }

    var savedColorPreference = localStorage.getItem('colorPreference');

    if (savedColorPreference) {
        applyColor(savedColorPreference === 'true');
    }

    toggleColor.addEventListener('change', function () {
        var isOn = this.checked;  

        applyColor(isOn);
        localStorage.setItem('colorPreference', isOn); 
    });

    var toggleAccessibility = document.getElementById('toggleAccessibility');
    var menuVisible = true;


    // Fonction pour faire apparaitre le menu d'accessibilité

    toggleAccessibility.addEventListener('click', function() {
        if (menuVisible) {
            bodyElement.classList.add('accessibility--open');
            menuVisible = false;
        } else {
            bodyElement.classList.remove('accessibility--open');
            menuVisible = true;
        }
    });

    document.addEventListener('DOMContentLoaded', function () {
        new Menu();
        new Theme();
        new Home();
        new Ecoindex();
        new Social();
        new Formation();
        new Accessibility();
        // Vérifiez si l'URL contient 'contact'
        var isContactUrl = window.location.href.includes('contact');

        // Vérifiez si un élément avec la classe 'contact' existe sur la page
        var contactElementExists = document.querySelector('.contact') !== null;

        // Si l'une des conditions est vraie, créez une nouvelle instance de Contact
        if (isContactUrl || contactElementExists) {
            new Contact();
        }
    });

})));
//# sourceMappingURL=main.min.js.map
